import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_PROTECTION_PLAN_TYPES } from 'mocks/queries';
import ProtectionPlanTypesContext from './ProtectionPlanTypesContext';

// Get protection plan types (for all products).
// When ProtectionPlanTypesProvider is in the tree (PDP pages), data comes from
// the server-side SWR cache and the Apollo query is skipped entirely, avoiding
// the ~7 MB re-fetch that exceeded the Next.js 2 MB fetch-cache cap.
const useAllProtectionPlanTypes = () => {
  const $ = _c(2);
  const contextData = useContext(ProtectionPlanTypesContext);
  const shouldUseContextData = contextData != null;
  let t0;
  if ($[0] !== shouldUseContextData) {
    t0 = {
      skip: shouldUseContextData
    };
    $[0] = shouldUseContextData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: apolloData
  } = useSuspenseQuery(GET_PROTECTION_PLAN_TYPES, t0);
  const data = shouldUseContextData ? contextData : apolloData;
  return data?.getProtectionPlanTypes?.plans;
};
export default useAllProtectionPlanTypes;